import React, { useState, useEffect } from 'react';
import { Box, Typography, Tooltip, CircularProgress } from '@mui/material';
import axios from 'axios';

const OpenRouterLimits = () => {
  const [limits, setLimits] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const openRouterApiKey = process.env.REACT_APP_OPENROUTER_API_KEY;
        if (!openRouterApiKey) {
          setError('No API key found');
          setLoading(false);
          return;
        }

        // Fetch limits
        const limitsResponse = await axios.get('https://openrouter.ai/api/v1/auth/key', {
          headers: {
            'Authorization': `Bearer ${openRouterApiKey}`,
            'HTTP-Referer': window.location.origin,
          }
        });
        setLimits(limitsResponse.data);

      } catch (err) {
        console.error('Error fetching OpenRouter data:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
    // Refresh data every 5 minutes
    const interval = setInterval(fetchData, 5 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <CircularProgress size={20} />
        <Typography variant="body2">Loading API data...</Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Tooltip title={`Error: ${error}`}>
        <Typography color="error" variant="body2">
          API Error
        </Typography>
      </Tooltip>
    );
  }

  if (!limits) {
    return null;
  }

  return (
    <Box sx={{ 
      display: 'flex', 
      alignItems: 'center', 
      gap: 3,
      '& > *': {
        borderRight: '1px solid #ddd',
        pr: 3,
        '&:last-child': {
          borderRight: 'none',
          pr: 0
        }
      }
    }}>
      <Tooltip title="Total requests made">
        <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          Usage: {limits.usage?.requests || 0}
        </Typography>
      </Tooltip>

      <Tooltip title="Rate limit requests">
        <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          Limit: {limits.rate_limits?.requests || 'N/A'}
        </Typography>
      </Tooltip>

      <Tooltip title="Rate limit interval (seconds)">
        <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          Interval: {limits.rate_limits?.interval || 'N/A'}s
        </Typography>
      </Tooltip>
    </Box>
  );
};

export default OpenRouterLimits;